import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c941989c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "not-found" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "message" }
const _hoisted_4 = { class: "sub-message" }

import { useRouter, useRoute } from 'vue-router';
import { $t } from '@/i18n';
import logoImage from '@/assets/logo.png';


export default /*#__PURE__*/_defineComponent({
  __name: 'Error404Page',
  setup(__props) {

const $router = useRouter();
const $route = useRoute();

function goBack() {
  if ($route.meta.previousRoute) {
    $router.push($route.meta.previousRoute); // Go back to the previous page
  } else {
    $router.push('/'); // Go to the home page
  }
}

return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("img", {
      src: _unref(logoImage),
      class: "logo"
    }, null, 8, _hoisted_2),
    _createElementVNode("h1", _hoisted_3, _toDisplayString(_unref($t)('PAGE_NOT_FOUND')), 1),
    _createElementVNode("p", _hoisted_4, _toDisplayString(_unref($t)('PAGE_NOT_EXIST')), 1),
    _createVNode(_component_v_btn, {
      variant: "flat",
      class: "back-button",
      text: _unref($t)('GO_BACK'),
      onClick: goBack
    }, null, 8, ["text"]),
    _createVNode(_component_router_link, {
      to: "/",
      class: "home-link"
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_unref($t)('GO_TO_HOME')), 1)
      ]),
      _: 1
    })
  ]))
}
}

})